import { combineReducers } from "redux";
import JobReducer from './jobReducer'
export default combineReducers({
    JobReducer
})